export const version = 'kunde-v1.20.0-SNAPSHOT-d76149f2f48cb5ad8954aa91ace325bac3e090d1';